import React, { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { DevModal } from "@components/Helpers";

function VKVideoEmbedPlayerModal({ url, thumb }) {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const iframeElem = useRef();

    const handleClose = () => setShow(false);

    const handleShow = () => setShow(true);

    return (
        <>
            {thumb && (
                <img
                    onClick={handleShow}
                    className="img-thumbnail dev-listing-img"
                    src={thumb}
                    alt="image"
                    style={{ cursor: "pointer" }}
                />
            )}

            <DevModal
                show={show}
                onHide={handleClose}
                body={
                    <>
                        <iframe
                            frameBorder={0}
                            src={url}
                            allowFullScreen={true}
                            ref={iframeElem}
                            width="100%"
                            height="300px"
                        />
                        <div className="mt-3">
                            <span>{t("Ссылка")}:</span>{" "}
                            <a href={url} target="_blank" style={{ wordWrap: "break-word" }}>
                                {url}
                            </a>
                        </div>
                    </>
                }
                footer={
                    <Button variant="light" onClick={handleClose}>
                        {t("Закрыть")}
                    </Button>
                }
            />
        </>
    );
}

export default VKVideoEmbedPlayerModal;
